<app-skip-link linkId="exitLink" label="Exit" [href]="exitLink"></app-skip-link>
<app-main-content>
  @if (storageItem) {
  <app-agreement
    title="Privacy Policy and Terms of Use"
    [text]="(terms$ | async)!"
    [storageItem]="storageItem"
    (cancelChange)="onCancel()"
    (agreeChange)="onAgree()"
  ></app-agreement>
  }
</app-main-content>
